import EnvironmentConfig from '../interfaces/EnvironmentConfig'

const production: EnvironmentConfig = {
    dashboardUrl: 'https://dashboard.casaretail.in',
    ruleServerUrl: 'https://api.casa.ajira.tech',
    apiServerUrl: 'https://api.customerstudio.ajira.tech',
    redmineUrl: 'https://redmine.casaretail.ai',
    casaWebAppUrl: 'https://web.casa.ajira.tech',
    onboardingDashboardUrl: 'https://onboarding.casaretail.ai',
    casaEcomUrl: 'https://ecom.casa.ajira.tech',
    casaBeatUrl: 'https://beat-api.casa.ajira.tech',
    turnedOffFeatures: [],
    ruleUiUrl: 'https://rules.casa.ajira.tech',
    nifiUrl: 'https://dataflow.casaretail.ai/connector-test',
    ruleServiceToken: 'Soop1kY7.WOW,2mR%qK[dGIi Y|s6+zteZ5{]:)>-%1j7~%q_r:,+n`(--F2^#+@',
    keycloakConfig: {
        url: `https://auth.casaretail.ai`,
        realm: `casa`,
        clientId: `casa_dashboard`,
    },
    financeOnboarding: {
        webhookUrl: 'https://n8n.casaretail.ai/webhook/finance-onboarding',
        submitToken: 'fb4yOjDdof5q5v9N4i8zKERMKtDKf0Jo',
        // reCAPTCHA v3 site key ("Casa Tenant Onboard Finance"). Public by design —
        // the secret half lives only in the n8n 'Web Config' node.
        recaptchaSiteKey: '6Lc17oEtAAAAAMnqd0yW_XEbjn0K1m5eF13sOF9z',
    },
}

export default production
